import { loaderAction, setChangeUserPasswordFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { CHANGE_USER_PASSWORD_FORM_INITIAL } from "../initialStateConstant";
import { api } from "../../helpers/api";

export const changeUserPasswordThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('u_id', args.u_id);
        formData.append('password', args.password);

        const response = await api({ data: formData, link: 'change_user_password' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму смены пароля
            dispatch(setChangeUserPasswordFormAction(CHANGE_USER_PASSWORD_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }

};